import React from 'react';
import { EventNameNav, EventNameNavProps } from '../components/EventNameNav';
import { WebsiteHeaderLayout_NoPhoto } from '../../../../hooks/useWebsiteHeaderSettings';

interface NoPhotoLayoutProps extends EventNameNavProps {
  websiteHeader: WebsiteHeaderLayout_NoPhoto;
  showPlaceholder?: boolean;
}

export const NoPhotoLayout = (props: NoPhotoLayoutProps) => {
  const { websiteHeader, showPlaceholder = false, ...restProps } = props;

  return (
    <EventNameNav
      eventDisplayName={websiteHeader.eventDisplayName}
      {...restProps}
    />
  );
};
